import { BlockStack, Icon, InlineStack, Link, Text } from '@shopify/polaris';
import { ArrowRightIcon } from '@shopify/polaris-icons';
import LiveSellingCard from '../Components/WelcomePage/LiveSellingCard';
import MobileAppCard from '../Components/WelcomePage/MobileAppCard';
import RecommendedFeaturesCard from '../Components/WelcomePage/RecommendedFeatures';
import PopclipsCard from '../Components/WelcomePage/PopclipsCard';
import { BaseLayout } from './Layout/BaseLayout';
import PlanChangeBanner from '../Components/Banners/PlanChangeBanner';
import PopclipsFeatureGatingBanner from '../Components/Banners/PopclipsFeatureGatingBanner';
import '../../assets/css/WelcomePage.css';
import { analyticsEventStore, shopStore } from '@/stores';
import { useSnapshot } from 'valtio';
import { useEffect } from 'react';

export default function WelcomePage() {
    const {
        subscriptionActive,
        csStoreCreated,
        popshopliveAccountCreated,
        progressPercentage,
        isVideeoSdkAndLivePageEnabled,
        isProductsPublishedToSalesChannel,
        isFirstPopclipCarouselPublished,
    } = useSnapshot(shopStore);

    useEffect(() => {
        if (
            subscriptionActive &&
            csStoreCreated &&
            popshopliveAccountCreated &&
            isVideeoSdkAndLivePageEnabled &&
            isProductsPublishedToSalesChannel
        ) {
            analyticsEventStore.browsingViewWelcomeScreen();
        }
    }, []);

    return (
        <BaseLayout
            title="👋 Welcome to Videeo!"
            subtitle={
                true ? undefined : (
                    <InlineStack gap="200">
                        <Text as="p" variant="bodyMd">
                            Setup questions?
                        </Text>
                        <div className="schedule-free-onboarding-call">
                            <Link
                                url="https://calendly.com/d/cmqk-5kn-95h"
                                removeUnderline
                                target="_blank"
                                onClick={() => analyticsEventStore.scheduleOnboardingCall()}
                            >
                                <InlineStack gap="100" blockAlign="center">
                                    <Text
                                        as="span"
                                        fontWeight="semibold"
                                        tone="magic"
                                    >
                                        Schedule a free onboarding call
                                    </Text>
                                    <Icon source={ArrowRightIcon} tone="magic" />
                                </InlineStack>
                            </Link>
                        </div>
                    </InlineStack>
                )
            }
            showProgressStatus={!isFirstPopclipCarouselPublished || progressPercentage !== 100}
        >
            <div style={{ marginBottom: '10px' }}>
                <PlanChangeBanner />
                <PopclipsFeatureGatingBanner />
            </div>
            <BlockStack gap="800">
                <PopclipsCard />
                <InlineStack gap="400" wrap={false}>
                    <RecommendedFeaturesCard />
                    <LiveSellingCard />
                    <MobileAppCard />
                </InlineStack>
            </BlockStack>
        </BaseLayout>
    );
};